export const VALIDATIONS = {
  EMAIL: {
    regex: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    message: '이메일 형식이 유효하지 않습니다.',
    messageEn: 'Please enter a valid email address.',
  },
  PHONE: {
    regex: /^[0-9]{10,11}$/,
    message: '전화번호 형식이 유효하지 않습니다.',
    messageEn: 'Please enter a valid phone number.',
  },
  TITLE: {
    regex: /^.{1,100}$/,
    message: '프로젝트명은 1자 이상 100자 이하여야 합니다.',
    messageEn: 'Project name must be between 1 and 100 characters.',
  },
};
